import Helper from '@ember/component/helper';
import { format } from 'd3-format';

export function formatNumber(
  [number]: [number | null | undefined],
  { specifier = ',' }: { specifier: string } = { specifier: ',' },
) {
  let func = format(specifier);
  let result = '0';

  if (number != null) {
    result = func(number);
  }

  // If an SI-like format is specified, billions will have a suffix of G - giga.
  // This is fine for scientific purposes, but we want to show B for Billions.
  if (result.includes('G')) {
    result = result.replace('G', 'B');
  }

  return result;
}

/*
  Basic Usage:

  ```handlebars
  {{format-number count}}
  ```
*/
export default Helper.helper(formatNumber);
